import axiosInstance from "app/axiosInstance";
import { SubscriptionsRequestDto } from "../entities/dtos/subscriptions-request.dto";

export const getSubscriptions = async (payload: SubscriptionsRequestDto) => {
  try {
    const { accountId, objectId } = payload;

    const response = await axiosInstance.get(
      `/accounts/${accountId}/objects/${objectId}/subscriptions`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
